namespace PaperTrail.NewsletterControl {
    export interface StyleSheetRow {
        StyleSheetId?: number;
        Title?: string;
        Font?: string;
        FontSize?: number;
        TextAlignment?: string;
        Height?: number;
        Width?: number;
        Padding?: string;
        Margin?: string;
        Rows?: number;
        Columns?: string;
        Rotation?: number;
        BackgroundColor?: string;
        ForeColor?: string;
        IsUnderline?: boolean;
        IsBold?: boolean;
        IsItalic?: boolean;
    }

    export namespace StyleSheetRow {
        export const idProperty = 'StyleSheetId';
        export const nameProperty = 'Title';
        export const localTextPrefix = 'NewsletterControl.StyleSheet';
        export const lookupKey = 'NewsletterControl.StyleSheet';

        export function getLookup(): Q.Lookup<StyleSheetRow> {
            return Q.getLookup<StyleSheetRow>('NewsletterControl.StyleSheet');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Newsletter:Contributor';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            StyleSheetId = "StyleSheetId",
            Title = "Title",
            Font = "Font",
            FontSize = "FontSize",
            TextAlignment = "TextAlignment",
            Height = "Height",
            Width = "Width",
            Padding = "Padding",
            Margin = "Margin",
            Rows = "Rows",
            Columns = "Columns",
            Rotation = "Rotation",
            BackgroundColor = "BackgroundColor",
            ForeColor = "ForeColor",
            IsUnderline = "IsUnderline",
            IsBold = "IsBold",
            IsItalic = "IsItalic"
        }
    }
}
